import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const emeraldCoastMetadata = {
  id: 'emerald-coast',
  name: 'Emerald Coast',
  description:
    'A fictional dune-and-shore links where rolling greens and firm turf reward wind-shaped ground shots.',
  environmentPreset: 'cloudy',
  metadata: {
    location: 'Cape Aster, North Atlantic',
    regionType: 'coastal links',
    difficulty: 75,
    typicalWind: [14, 26] as const,
    greenSpeed: [11, 11.5] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Prevailing wind, compact bunkers and preferred approach angles',
    signatureHoles: [5, 8, 12, 18],
    tournamentEventId: 'event-3',
    previewTheme: 'emerald-dunes',
    environmentPalette: {
      fairway: '#77945b',
      rough: '#b5a56b',
      bunker: '#e1cf9b',
      water: '#315f71',
      haze: '#b9c7c5',
    },
    vegetationStyle: 'dune grass with very few wind-bent trees',
    terrainStyle: terrainPreset('coastal-dunes', 7, 95, 1.4).id,
  },
};
const pars = [4, 4, 3, 5, 4, 4, 3, 3, 4, 5, 4, 5, 4, 3, 4, 4, 5, 4],
  yards = [
    420, 445, 175, 570, 320, 465, 190, 225, 410, 545, 450, 555, 430, 160, 395, 470, 585, 390,
  ],
  names = [
    'Outward',
    'Marram',
    'Sea Glass',
    'Long Dune',
    'Cape Gamble',
    'Hollows',
    'Gull',
    'North Wind',
    'Firm Run',
    'Dune Thread',
    'Salt Pan',
    'Emerald Reach',
    'Brae',
    'Pottery',
    'Cross Shore',
    'Old Beacon',
    'Homeward Dunes',
    'Shoreline',
  ];
const o: Partial<HolePlan>[] = [];
o[4] = {
  landingZones: [{ distance: 245, width: 58, preferredSide: 'left' }],
  bunkerCount: 5,
  trees: 0,
};
o[7] = { trees: 0 };
o[11] = { trees: 0, bunkerCount: 4 };
o[17] = { water: 'right', trees: 0 };
export const createEmeraldCoastDocument = () =>
  authorCourse({
    ...emeraldCoastMetadata,
    plans: plans(names, pars, yards, o).map((p) => ({ ...p, trees: p.trees ?? 1 })),
  });
